import AuthGuard from 'guards/AuthGuards';
import { lazy } from 'react';
import Path from './paths';

const routes = [
  {
    path: Path.HOME,
    component: lazy(() => import('views/Home')),
    exact: true
  },
  {
    path: Path.UI_DOCS,
    component: lazy(() => import('views/UiDocs')),
    exact: true
  },
  {
    path: Path.ADD_MEMBER,
    component: lazy(() => import('views/AddMember')),
    exact: true
  },
  {
    path: Path.ID_CARD_PREVIEW,
    component: lazy(() => import('views/EmployeeIdCardPreviewPage')),
    exact: true
  },
  {
    guard: AuthGuard,
    path: `${Path.DASHBOARD}/*`,
    component: lazy(() => import('views/dashboard')),
    exact: true
  }
];

export default routes;
